module.exports = __webpack_public_path__ + "static/media/section-3-2@2x.e5b1ebee.png";